import React, { useEffect, useMemo, useState } from 'react';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { ExportIcon } from '../components/icons/icons';
import GrayButton from '../components/submissions-database/GrayButton';
import Table from '../components/atoms/table';
import UserStatusDropDown from '../components/user-setting/UserStatusDropDown/UserStatusDropDown';
import Profile from '../components/Profile';
import { getUsersInCompany } from '../api/user-setting';
import toast from 'react-hot-toast';
import UserDefaultGroupDropDown from 'components/user-setting/UserDefaultGroupDropDown/UserDefaultGroupDropDown';
import CountLabel from 'components/atoms/CountLabel';

const Container = styled.div`
  font-family: 'Inter', sans-serif;
  border: 1px solid #2d3748;
  border-radius: 1rem;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
`;

const UserSettingPage = () => {
  const [users, setUsers] = useState([]);
  const [company, setCompany] = useState(' ');
  const [loading, setLoading] = useState(false);

  const getSetUserList = async () => {
    try {
      setLoading(true);
      const userInCompanyRes = await getUsersInCompany();
      const userInCompanyData = userInCompanyRes?.data;
      setUsers(userInCompanyData?.users || []);
      setCompany(userInCompanyData?.company_name || ' ');
    } catch (e) {
      toast.error(e?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSetUserList();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => (
          <Profile text={row?.original?.first_name} subText={row?.original?.last_name} />
        )
      },
      { accessorKey: 'email', header: 'Email' },
      {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row }) => (
          <UserStatusDropDown status={row.original.company.status} userId={row.original._id} />
        )
      },
      {
        accessorKey: 'default',
        header: 'Default Group',
        cell: ({ row }) => (
          <UserDefaultGroupDropDown
            defaultGroup={row?.original?.default_group}
            userId={row?.original?._id}
          />
        )
      }
    ],
    []
  );

  return (
    <Container className="bg-gradient-to-b from-gradientLight-100 to-gradientLight-200">
      <Header>
        <div>
          <h1 className="text-xl font-semibold">{company}</h1>
          <p className="text-sm">
            <CountLabel
              loading={loading}
              length={users?.length}
              singularLabel="Member"
              pluralLabel="Members"
            />
          </p>
        </div>
        <div className="flex gap-2">
          <GrayButton text="Export CSV" icon={<ExportIcon />} />
        </div>
      </Header>
      <Table columns={columns} data={users} />
    </Container>
  );
};

export default UserSettingPage;
